module.exports = __webpack_public_path__ + "static/img/td.246d767.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/td.png
// module id = PDH6
// module chunks = 1